var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"width":"100%","height":"620px","src":"https://sports.sina.cn/running/index.d.html?vt=4&pos=10"}})
}
var staticRenderFns = []

export { render, staticRenderFns }